// extracted by mini-css-extract-plugin
export var cls1 = "SemicorcheaAbiertaSvg-module--cls-1--XceMh";